import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { Link, NavLink, NavLinkRenderProps } from "react-router";
import styled from "styled-components";
import { useWindowSize } from "usehooks-ts";

const Container = styled.nav`
    position: fixed !important;
    width: 100%;
    display: flex;
    flex-shrink: 0;
    top: 0;
    background: var(--lemonade);
    padding: 1rem 2rem;
    gap: 4rem;
    z-index: 9;

    ul.links {
        list-style: none;
        display: flex;
        gap: 0.5rem;
        align-items: center;
        flex-grow: 1;
        justify-content: space-between;
        width: fit-content;

        li {
            display: flex;
            color: #fff;
            font-family: "Professor Marbles 3";
            font-size: 2rem;
            font-weight: 400;
            letter-spacing: -0.15rem;

            a {
                position: relative;
                color: var(--white);
                text-decoration: none;

                &::after {
                    --color: #ffffff3e;
                    --background: var(--white);
                    content: "";
                    position: absolute;
                    bottom: 1px;
                    left: 0;
                    width: 0%;
                    height: 3px;
                    background-color: var(--background);
                    border-radius: 3px;
                    /* opacity: 0; */
                    transition: all 0.3s;
                    box-shadow: 0px 0px 5px 5px #ffffff00;
                }

                &:hover::after,
                &.active::after {
                    opacity: 1;
                    width: 100%;
                    transition: all 0.15s;
                    box-shadow: 0px 0px 5px 5px var(--color);
                    text-shadow: 0px 0px 5px var(--color);
                }

                &:hover {
                    text-shadow: 0px 0px 5px var(--color);
                }
            }

            &.special {
                padding: 0.25rem 1rem;
                padding-top: 0.5rem;
                border-radius: 1.32488rem;
                background: var(--cyan);
                text-align: center;
                transition: 0.2s;

                a::after {
                    visibility: hidden;
                }

                &:hover {
                    transform: scale(1.1);
                    background: var(--blue);
                }

                &:active {
                    transform: scale(0.9);
                }
            }
        }

        .divider {
            display: flex;
            content: "";
            width: 0.1rem;
            background: #ffffffa4;
            height: 50px;
        }
    }

    img {
        height: 5rem;
        z-index: 15;
    }

    @media (max-width: 1400px) {
        ul.links li {
            font-size: 1.5rem !important;
        }
    }

    .burguer {
        margin-left: auto;

        svg {
            stroke-width: 0;
        }
    }

    &.small .links {
        position: absolute;
        top: 7rem;
        left: 0;
        width: 100%;
        height: fit-content;
        bottom: 0;
        background: var(--white);
        z-index: -1;
        padding: 2rem 4rem;
        padding-right: 8rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        z-index: 8;
        flex-grow: 0;

        li {
            margin-bottom: 1rem;
            font-size: 1.5rem;
            font-weight: bold;

            flex-grow: 0;
            a {
                font-size: 3rem;
                color: var(--dark-blue);
            }
        }

        .divider {
            width: 100%;
            height: 1px;
            background-color: var(--dark-blue);
        }
    }
    &.open {
        z-index: 15;

        a::after {
            --background: var(--dark-blue) !important;
        }
    }
`;

export const Navbar = () => {
    const { width = 0 } = useWindowSize();
    const [isOpen, setOpen] = useState(false);

    const isSmall = width <= 1000;

    useEffect(() => {
        if (isOpen && !isSmall) {
            return setOpen(false);
        }
        // if (!isOpen && isSmall) {
        //     return setOpen(true);
        // }
    }, [isOpen, isSmall]);

    return (
        <Container
            className={
                String(isSmall ? "small" : "") + String(isOpen ? " open" : "")
            }
            // style={isOpen ? { position: "", zIndex: 10 } : {}}
        >
            <Link to={"/"}>
                <img
                    src="/logos/logo-nav.png"
                    alt="Logo"
                    className="logo no-shadow"
                />
            </Link>
            {width <= 1000 && (
                <button
                    className="burguer"
                    onClick={() => {
                        setOpen(!isOpen);
                    }}
                >
                    <svg
                        width="38"
                        height="27"
                        viewBox="0 0 38 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.013916 4.5625C0.013916 2.54896 1.64621 0.916666 3.65975 0.916666H34.2153C36.2288 0.916666 37.8611 2.54896 37.8611 4.5625C37.8611 6.57604 36.2288 8.20833 34.2153 8.20833H3.65976C1.64622 8.20833 0.013916 6.57604 0.013916 4.5625Z"
                            fill="white"
                        />
                        <path
                            d="M0.013916 13.5903C0.013916 11.5767 1.64621 9.94444 3.65975 9.94444H34.2153C36.2288 9.94444 37.8611 11.5767 37.8611 13.5903C37.8611 15.6038 36.2288 17.2361 34.2153 17.2361H3.65976C1.64622 17.2361 0.013916 15.6038 0.013916 13.5903Z"
                            fill="white"
                        />
                        <path
                            d="M0.013916 22.9653C0.013916 20.9517 1.64621 19.3194 3.65975 19.3194H34.2153C36.2288 19.3194 37.8611 20.9517 37.8611 22.9653C37.8611 24.9788 36.2288 26.6111 34.2153 26.6111H3.65976C1.64622 26.6111 0.013916 24.9788 0.013916 22.9653Z"
                            fill="white"
                        />
                    </svg>
                </button>
            )}
            <AnimatePresence initial={false}>
                {!!(!isSmall || isOpen) && (
                    <motion.ul
                        className="links prof-marbles-1"
                        exit={{ opacity: 0 }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to="/atracoes"
                            >
                                Atrações
                            </NavLink>
                        </li>
                        <span className="divider"></span>
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to={"/historia"}
                            >
                                Conheça a vila
                            </NavLink>
                        </li>
                        <span className="divider"></span>
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to="/festas"
                            >
                                Festas
                            </NavLink>
                        </li>
                        <span className="divider"></span>
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to="/escolas"
                            >
                                Escolas
                            </NavLink>
                        </li>
                        <span className="divider"></span>
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to="/faq"
                            >
                                Faq
                            </NavLink>
                        </li>
                        <span className="divider"></span>
                        <li>
                            <NavLink
                                className={(e) => (e.isActive ? "active" : "")}
                                to="/contato"
                            >
                                Contato
                            </NavLink>
                        </li>
                        <li className="special">
                            <NavLink
                                className={(e: NavLinkRenderProps) => {
                                    let className = "cart-link-button-menu";
                                    if (e.isActive)
                                        className = className + " active";
                                    return className;
                                }}
                                to="/checkout"
                            >
                                Compre seu Ingresso
                            </NavLink>
                        </li>
                    </motion.ul>
                )}
            </AnimatePresence>
        </Container>
    );
};
